import KpiCard from "@/components/KpiCard.vue";
import PercentageValue from "@/components/tableElements/PercentageValue.vue";
import NumberValue from "@/components/tableElements/NumberValue.vue";
import { COLORS } from "@/utils/constants";
import { getDescriptionBasedOnKpiKey } from "@/utils/transformers";
const {
  title,
  detail
} = getDescriptionBasedOnKpiKey("traffic_by_asin_buy_box_percentage");
export default {
  name: "ListingBuyBoxCard",
  props: {
    amount: {
      type: Number
    },
    percentage: {
      type: Number
    },
    loading: {
      type: Boolean
    }
  },
  components: {
    KpiCard,
    PercentageValue,
    NumberValue
  },
  data() {
    return {
      COLORS,
      title,
      detail
    };
  }
};